// Browser-only pdfmake 0.2.20 bundles; all four Roboto faces are embedded VFS data.
// No URL fonts, images, CDN, print dialog, upload or monetary Number conversion.
const fonts = { Roboto: { normal: "Roboto-Regular.ttf", bold: "Roboto-Medium.ttf",
    italics: "Roboto-Italic.ttf", bolditalics: "Roboto-MediumItalic.ttf" } };
let engine;
async function loadEngine() {
    engine ||= Promise.all([import("pdfmake/build/pdfmake"), import("pdfmake/build/vfs_fonts")]).then(([pdf, fontData]) => {
        const make = pdf.default || pdf, vfs = fontData.default || fontData;
        if (typeof make.createPdf !== "function" || Object.values(fonts.Roboto).some(name => typeof vfs[name] !== "string"))
            throw Error("CHECK_PDF_RUNTIME_OR_FONTS_INVALID");
        return { make, vfs };
    });
    return engine;
}
export function createPDFDefinition(snapshot) {
    const value = display => ({ text: display });
    const content = (snapshot.pdfHeader || snapshot.header.filter(text => /^(Order:|Store:|Ordered:|Items with differences:)/.test(text))).map(text => ({ text, margin: [0, 0, 0, 4] }));
    if (!snapshot.products.length) content.push({ text: snapshot.emptyMessage, margin: [0, 10, 0, 10] });
    for (const product of snapshot.products) {
        content.push({ text: `FS ProductID ${product.productID}`, headlineLevel: 1, bold: true, fontSize: 12, color: "#875300", margin: [0, 14, 0, 6] });
        content.push({ table: { headerRows: 1, widths: [90, 215, 215, "*"], body: [
            ["Field", "Front Systems", "Incoming", "Difference"].map(text => ({ text, bold: true, fillColor: "#eeeeee" })),
            ...product.rows.map(row => [row.label, value(row.before), value(row.incoming), row.difference])
        ] }, layout: "lightHorizontalLines" });
    }
    // A bounded header keeps long names without allowing unbounded header growth.
    const rawBrand = typeof snapshot.labelBrandName === "string" ? snapshot.labelBrandName.replace(/\s+/g, " ").trim() : "";
    const brand = rawBrand ? [...rawBrand].slice(0, 90).join("") + ([...rawBrand].length > 90 ? "…" : "") : "Unavailable";
    const brandWords = brand.replace(/(\S{20})(?=\S)/gu, "$1\u200b");
    return { info: { title: snapshot.subject, subject: "Informational CHECK; no export performed" },
        pageSize: "A4", pageOrientation: "landscape", pageMargins: [36, 76, 36, 36],
        defaultStyle: { font: "Roboto", fontSize: 9 }, content,
        header: () => ({ margin: [36, 18, 36, 0], columns: [
            { text: "nanaBO / BUYING INTELLIGENCE", bold: true, fontSize: 9, width: "*" },
            { text: "Label Brand - " + brandWords, alignment: "right", bold: true, fontSize: 9, width: 300, lineHeight: 1.15 }
        ] }),
        footer: (page, count) => ({ text: `Page ${page} / ${count}`, alignment: "right", margin: [36, 10, 36, 0], fontSize: 8 }),
        pageBreakBefore: (current, following) => current.headlineLevel === 1 && (!following.some(node => node.table) ||
            !!current.startPosition && (1 - current.startPosition.verticalRatio) * current.startPosition.pageInnerHeight < 80) };
}
export async function createPDFFile(snapshot) {
    const { make, vfs } = await loadEngine();
    // Public getStream() is synchronous with local VFS fonts, allowing errors to
    // reject this promise. No private pdfmake methods or remote font resolver.
    return new Promise((resolve, reject) => {
        try {
            const stream = make.createPdf(createPDFDefinition(snapshot), null, fonts, vfs).getStream();
            const chunks = [];
            stream.on("data", chunk => chunks.push(chunk));
            stream.on("error", () => reject(Error("CHECK_PDF_GENERATION_FAILED")));
            stream.on("end", () => resolve(new File(chunks, "Front-Systems-CHECK.pdf", { type: "application/pdf" })));
            stream.end();
        } catch { reject(Error("CHECK_PDF_GENERATION_FAILED")); }
    });
}
